import React, {useState} from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {safeHTML} from "../../utils/safeHTML";
import classNames from "classnames";
import {CSSTransition, SwitchTransition} from "react-transition-group";
import styles from "./Quiz.module.scss"

const QuizItem = React.forwardRef(
  function QuizItem(props, ref) {
    const {activeItem, length, image, text, quizAnswers, next} = props;

    const [activeOption, setActiveOption] = useState(null);
    const [itemScore, setItemScore] = useState();

    const items = quizAnswers?.map((item, index) => {
      const {invalid_text, valid_text} = item;
      const tooltip = invalid_text || valid_text;
      return (
      <div key={`option-${index}`}
           className={classNames(styles.quiz__itemOption, {
             [styles.quiz__itemOption_active]: activeOption === index,
             [styles.quiz__itemOption_disabled]: activeOption !== null && tooltip?.length > 0
           })}
           onClick={() => {
             setItemScore(item?.score);
             setActiveOption(index);
           }}
      >
        <div className={styles.quiz__itemOptionIcon}/>
        <div className={styles.quiz__itemOptionText}>{safeHTML(item?.text)}</div>
        <SwitchTransition>
          <CSSTransition key={activeOption !== null && activeOption === index ? "tooltip-show":"tooltip-hide"}
                         timeout={300}
                         classNames={{
                           enter: styles.quiz__itemOptionTooltipEnter,
                           enterActive: styles.quiz__itemOptionTooltipEnterActive,
                           enterDone: styles.quiz__itemOptionTooltipEnterDone,
                           exit: styles.quiz__itemOptionTooltipExit,
                           exitActive: styles.quiz__itemOptionTooltipExitActive,
                           exitDone: styles.quiz__itemOptionTooltipExitDone
                         }}
          >
            {
              activeOption !== null && activeOption === index && tooltip?.length > 0 ?
                <div className={classNames(styles.quiz__itemOptionTooltip,{
                    [styles.quiz__itemOptionTooltip_wrong]:invalid_text,
                    [styles.quiz__itemOptionTooltip_right]:valid_text,
                  }
                )}>
                  <span>{safeHTML(tooltip)}</span>
                </div>
                :<></>
            }
          </CSSTransition>
        </SwitchTransition>



      </div>
    )});
    return (
      <div className={styles.quiz__item} ref={ref}>
        <div className={styles.quiz__itemImage}>
          <img src={image} alt="" loading="lazy" fetchpriority={"auto"} width={1312} height={600}/>
        </div>
        <div className={styles.quiz__itemContent}>
          <div className={styles.quiz__itemCount}>{`${activeItem + 1} / ${length}`}</div>
          <h2 className={styles.quiz__itemTitle}>{safeHTML(text)}</h2>
          <div className={styles.quiz__itemItems}>
            {items}
          </div>
          <Button className={classNames(
            buttonStyles.button_black,
            buttonStyles.button_big,
            styles.quiz__itemButton
          )}
                  disabled={activeOption === null}
                  onClick={()=>next(itemScore)}
          >
           <span className={buttonStyles.button__text}>
             {activeItem + 1 < length ? "Продолжить" : "Результаты"}
           </span>
          </Button>
        </div>
      </div>
    );
  });
export default QuizItem;
QuizItem.propTypes = {};

